import React, { useState, useEffect } from 'react'
import Cookies from 'js-cookie';

function Student_password({setPassord, setSPw, uniq}) {

  const [password, setPassword] = useState()
  const [secondpp, setSecondpp] = useState()
  const [subbtn, setSub] = useState(false)
  

  const sub = () =>{
    
    if(password!=secondpp)
    {
      alert('passwords do not match')
    }

    else{
     
      

      const loginData = {
      
        uniq: uniq,
        password: password,
      
       };
 
             // Send data to the PHP backend using fetch
             fetch('https://hosteladventures.site/PHP/Student_password.php', {
               method: 'POST',
               headers: {
                 'Content-Type': 'application/json'
               },
               body: JSON.stringify(loginData)
             })
               .then(response => response.json())
               .then(data => {
                 // Handle response from backend (e.g., login success or failure)
                 if(data.message=='password uploaded successfully')
                 {
                  Cookies.set('user', password, { expires: 365 });
                  alert('Congratulations!! All good!!')
                   
                 }

                 console.log(data)
              
               })
               .catch(error => {
                 console.error('Error:', error);
               });
    }
  }

  useEffect(()=>{

   if(password&&secondpp)
   {
    setSub(true)
   }

   else{
    setSub(false)
   }
    

  },[password, secondpp])

  
  return (
    <div className='whole_IMG'>
      <div>
        <p className='fill_In'>Create Password</p>
        <input placeholder='create password' type='password' onChange={(event) => setPassword(event.target.value)}  />
        <input placeholder='confirm password'type='password' onChange={(event) => setSecondpp(event.target.value)} />
        {subbtn==true?(<div><button onClick={sub} className='submt_btn'>Submit</button></div>):('')}
       
      </div>
    </div>
  )
}

export default Student_password
